import AssignmentTable from '@/components/tables/assignment-table';

const CourseAssignmentsPage = () => {
  return <AssignmentTable />;
};

export default CourseAssignmentsPage;
